import NewRecordModalComponent from "./NewRecordModalComponent";

export default NewRecordModalComponent;
